module.exports = __webpack_public_path__ + "img/7类1级.4a8c5fdf.webp";